module.exports = __webpack_public_path__ + "img/search-icon.809873b5.svg";